// React
import { useDispatch, useSelector } from "react-redux";

// Syncfusion
import { MultiSelectComponent } from "@syncfusion/ej2-react-dropdowns"

// Store
import { setValue } from "../../../store/formData/actions";
import { getFieldValue } from "../../../store/formData/selectors";
import { fieldValid } from "../../../store/pages/selectors";

// Style
import "./MultiDropdown.scss";

export default function MultiDropdown({
  formName,
  fieldName,
  widgetData,
}) {
  const dispatch = useDispatch();

  const { options, placeholder, label } = widgetData;

  const value =
    useSelector( ( state ) => getFieldValue(state, fieldName));

  const fields = {
    text: "placeholder",
    value: "value",
  };

  function change({ value }) {
    dispatch(setValue({ formName, fieldName, value }));
  }

  const { isValid, showValidation } =
    useSelector((state) => fieldValid( state, fieldName ));


  return (
    <div className={ (!isValid && showValidation ) ? "multi-dropdown form-field invalid" : "multi-dropdown form-field" }>
      <MultiSelectComponent
        fields={fields}
        dataSource={options}
        placeholder={placeholder}
        change={change}
        value = {value}
      />
    </div>
  );
}
